import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

interface TrustNoteWrapperProps {
  withModalOffset: boolean
}

// Modal header bottom padding and body top padding add up to 24px. Pull the note up only there.
export const TrustNoteWrapper = styled.div<TrustNoteWrapperProps>`
  margin-top: ${({ withModalOffset }) => (withModalOffset ? `-${Spacing.S12}` : '0')};
  margin-bottom: ${Spacing.S12};
`
